<template>
  <DataList
    title="Департаменти"
    resource="departments"
    :disable-adding="!isAdmin"
    :readonly="!isAdmin"
    :columns="columns"
    :get-items-fn="getDepartments"
  />
</template>

<script>
import * as departmentsApi from "../../../backend/departmentsApi.js";
import auth from "@/auth.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title", rowType: "wide" },
    ],
  }),
  computed: {
    isAdmin() {
      return auth.isAdmin();
    },
  },
  methods: {
    getDepartments(...args) {
      return departmentsApi.getDepartments(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>